var getInitialValue = function getInitialValue(initialValues, field) {
  var isAlreadySet = Object.keys(initialValues).includes(field.name);
  var value = isAlreadySet ? initialValues[field.name] : field.value;
  return value || '';
};
var getInitialValue$1 = getInitialValue;

export { getInitialValue$1 as default };
//# sourceMappingURL=utils.js.map
